import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DecisionLevel } from '../../../../shared/enums/decision-level';
import { NgClass } from '@angular/common';
import { Decision } from '../../../../shared/models/internal/decision';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-decision-modal',
  imports: [NgClass, AgentActionDirective],
  templateUrl: './decision-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './decision-modal.component.scss',
})
export class DecisionModalComponent {
  @Input() public header = '';
  @Input() public details = ['Are you sure?'];
  @Input() public entityId?: string;
  @Input() public entityName?: string;
  @Input() public businessObject?: string;
  @Input() public yesNoButtons = true;
  @Input() public buttons = [{ text: '', value: '' }];
  @Input() public decisionLevel = DecisionLevel.Error;
  @Input() public listTitle?: string;
  @Input() public list?: string[];
  @Output() public decision = new EventEmitter<Decision>();

  public level = DecisionLevel;
  public isDecisionModalVisible = false;

  public decide(decision: boolean, value?: string): void {
    const result: Decision = {
      result: decision,
      value: value,
    };

    this.decision.emit(result);
    this.closeModal();
  }

  public closeModal(): void {
    this.isDecisionModalVisible = false;
  }

  public openModal(): void {
    this.isDecisionModalVisible = true;
  }
}
